module.exports = "<p>\n  despesa-planejamentos works!\n</p>\n"